import React from 'react';
import { Box, Stack, useTheme } from '@mui/material';
import { faClapperboardPlay } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SubwayMenu } from './SubwayMenu';
import { StatusChip } from './StatusChip';
import type { SubwayEntityProps } from './types';
import {
  StyledSubwayNavContainer,
  StyledSubwayEntityRow,
  StyledIdTypography,
  StyledTitleTypography,
  StyledCreativeContainer,
  StyledCreativeTypography,
} from './styles';
import { iconList, entityVariant, entityIdPrefix } from './constants';

export const SubwayEntity = ({
  variant,
  id,
  title,
  status,
  creativeNames,
  menuOptions,
  selected,
  disableMenu = false,
  sectionKey,
  ...props
}: SubwayEntityProps) => {
  const theme = useTheme();

  return (
    <Stack {...props} width="100%">
      <StyledSubwayNavContainer
        selected={selected}
        variant={variant}
        id={`subway-entity-${sectionKey}-header`}
        data-testid="subway-entity-bg"
      >
        <StyledSubwayEntityRow
          direction="row"
          spacing={1.125}
          alignItems="center"
          justifyContent="flex-start"
          variant={variant}
        >
          <FontAwesomeIcon
            icon={iconList[variant]}
            width={10}
            height={10}
            color={selected ? 'text.primary' : theme.palette.grey[4]}
          />
          <StyledIdTypography selected={selected} noWrap>
            {id
              ? `${entityIdPrefix[variant]}${id}`
              : variant === entityVariant.group
              ? 'Ad Group'
              : 'Campaign'}
          </StyledIdTypography>
          <StatusChip status={status} />
        </StyledSubwayEntityRow>
        <StyledSubwayEntityRow
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          variant={variant}
        >
          <StyledTitleTypography selected={selected} noWrap={!selected}>
            {title}
          </StyledTitleTypography>
          {menuOptions && (
            <SubwayMenu
              onClick={e => {
                e.stopPropagation();
              }}
              options={menuOptions}
              disabled={disableMenu}
            />
          )}
        </StyledSubwayEntityRow>
      </StyledSubwayNavContainer>
      {selected && (
        <StyledCreativeContainer
          selected={selected && !!creativeNames?.length}
          variant={variant}
        >
          {creativeNames?.map((name, index) => (
            <Box key={index}>
              <FontAwesomeIcon
                icon={faClapperboardPlay}
                width={10}
                height={10}
              />
              <StyledCreativeTypography>{name}</StyledCreativeTypography>
            </Box>
          ))}
        </StyledCreativeContainer>
      )}
    </Stack>
  );
};
